import Vue from 'vue'
import { IMAGES_URL } from '@/api/api'
Vue.mixin({
  computed: {
    desarrollo () {
      return process.env.NODE_ENV === 'development'
    },
    logo () {
      return window.logo ? window.logo : require('@/assets/images/logo.png')
    }
  },
  methods: {
    removeDecimalInput (valor) {
      return Number(this.$options.filters.removeDecimalInput(valor))
    },
    decimalInput (valor) {
      return this.$options.filters.decimalInput(valor)
    },
    $apiDocument (document) {
      if (document) {
        return IMAGES_URL + encodeURI(`?jsondata={"parametros":{"id":${document.id}}}`)
      } else {
        return '' // TODO DEVOLVER PLACEHOLDER
      }
    },
    waitMiliseconds (ms) {
      return new Promise((resolve, /* reject */) => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    }
  }
})
